export enum FavoritesEnum {
	Materials = 'Materials',
	ScanBodies = 'ScanBodies',
	Implants = 'Implants',
	SendTo = 'SendTo'
}
